// extracted by mini-css-extract-plugin
export var centerText = "_da-8";
export var container = "_da-0";
export var doughnutContainer = "_da-7";
export var legend = "_da-a";
export var legendItemColorDisplay = "_da-b";
export var legendItemLabel = "_da-d";
export var legendItemValue = "_da-c";
export var lg = "_da-5";
export var maxWidth = "_da-9";
export var md = "_da-4";
export var responsive = "_da-6";
export var sm = "_da-3";
export var xs = "_da-2";
export var xxs = "_da-1";